import type {
    ClassicalGridItem,
    ClassicalApiUberArtwork,
} from '@jet-app/music-classical/api/types';
import type { Opt } from '@jet/environment/types/optional';

export interface Artwork {
    template: string;
    width: number;
    height: number;
    backgroundColor?: Opt<string>;
}

export enum VideoArtworkCropStyle {
    BoundedBox = 'bb',
    SpecificRectangle = 'sr',
    SquareCenterCrop = 'cc',
}

export interface VideoArtworkDictionaryItem {
    previewFrame: Artwork;
    video: string;
}
export interface VideoArtworkDictionary {
    phone?: VideoArtworkDictionaryItem;
    tablet?: VideoArtworkDictionaryItem;
}

export interface VideoArtwork {
    dictionary: VideoArtworkDictionary;
    cropStyle?: Opt<VideoArtworkCropStyle>;
}

export function fixArtwork(
    image: ClassicalGridItem['image'],
): Artwork | undefined {
    if (image) {
        const template = image.url ?? image.image?.url;
        if (template && isValidUrl(template)) {
            return {
                template,
                width: null,
                height: null,
                backgroundColor:
                    image.backgroundColorArtwork || image.bgColor || null,
            };
        }
    }
}

export function makeVideoArtworkDictionary(
    uberArtwork?: ClassicalApiUberArtwork,
): VideoArtwork | null {
    if (!uberArtwork) {
        return null;
    }

    const dictionary: VideoArtworkDictionary = Object.keys(uberArtwork).reduce(
        (acc, key) => {
            const { motionArtwork } = uberArtwork[key];

            // uberArtwork keys may contain only staticArtwork obejcts, so ensure that we have
            // an object for motion videos before adding to the dictionary
            if (motionArtwork) {
                acc[key] = {
                    previewFrame: fixArtwork(motionArtwork.previewFrame),
                    video: motionArtwork.url,
                };
            }

            return acc;
        },
        {},
    );

    if (!Object.keys(dictionary).length) {
        return null;
    }

    return { dictionary };
}

function isValidUrl(template: string): boolean {
    try {
        new URL(template);
        return true;
    } catch {
        return false;
    }
}
